import { render } from "./cgeEmail.vue?vue&type=template&id=31d5d410&scoped=true"
import script from "./cgeEmail.vue?vue&type=script&lang=js"
export * from "./cgeEmail.vue?vue&type=script&lang=js"

import "./cgeEmail.vue?vue&type=style&index=0&id=31d5d410&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d5d410"]])

export default __exports__